// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "9d0b639e79d86860edd6b555843003ec" + ".css";
};